import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

const VideoScrubber = (() => {
    async function getBlob ( src ) {
        try {
            const resp = await fetch( src );
            return resp.blob();
        }
        catch ( err ) {
            console.error( err );
            return null;
        }
    }

    function initScrubbingTimeline ( video ) {
        gsap.timeline( {
            defaults: {
                duration: video.duration
            },
            scrollTrigger: {
                // trigger: '#brand-product-highlight-scrubber',
                trigger: '#brand-video-scrub-start',
                endTrigger: '#brand-video-scrub-end',
                start: 'top top',
                end: 'bottom bottom',
                // markers: true,
                scrub: true
            }
        } ).fromTo( video,
            {
                currentTime: 0
            },
            {
                currentTime: video.duration || 1
            } );
        ;

        gsap.timeline( {
            scrollTrigger: {
                trigger: '#brand-video-opacity-start',
                endTrigger: '#brand-video-opacity-end',
                start: 'top top',
                end: 'bottom top',
                // markers: true,
                scrub: true
                // toggleActions: 'play pause reverse resume'
            }
        } ).fromTo( video,
            {opacity: 0.0},
            {opacity: 1.0}
        );

    }

    return {
        create: ( video ) => {
            if ( !video ) {
                throw Error( `[VideoScrubber] Expected videoElement but received ${video} instead` );
            }

            video.style.opacity = 0;
            gsap.registerPlugin( ScrollTrigger );

            let src = video.currentSrc || video.src;

            async function start () {
                video.addEventListener( 'loadedmetadata', () => initScrubbingTimeline( video ) )

                const blob = await getBlob( src );
                const blobUrl = URL.createObjectURL( blob );
                const t = video.currentTime;

                video.setAttribute( 'src', blobUrl );
                video.setAttribute( 'currentTime', t + .01 );
            }

            return {start};
        }
    };

})(); 

async function main () {
    const videoEl = document.getElementById( 'ultrapro-video-scrub' );
    if ( videoEl ) {
        const scrubber = VideoScrubber.create( videoEl );
        scrubber.start();
    }

    /* Mobile videos for <section> .brand-product-highlight */
    // const productHighlightGroups = document.querySelectorAll( '.brand-product-highlight--container .collapse-group' );
    // const observerOptions = {
    //     childList: false,
    //     attributes: true,
    //     attributeFilter: ['class']
    // };
    // const observer = new MutationObserver( ( changes ) => {
    //     changes.forEach( ( {target} ) => {
    //         // if <video> child present reset playback to 0 when accordion group becomes active
    //         if ( target.classList.contains( 'collapse-group--active' ) ) {
    //             const video = target.querySelector( 'video' );
    //             if ( video != null ) {
    //                 video.currentTime = 0.1;
    //             }
    //         }
    //     } )
    // } );
    // Array.from( productHighlightGroups ).forEach( n => observer.observe( n, observerOptions ) );
}

main().catch( error => {
    console.error( error );
} );

